const INITIAL_STATE = {
  showButtons: 0
};

export const skateparkHomeReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case 'SHOW_SKATEPARK_BUTTONS':
      return {
        ...state,
        showButtons: action.payload
      };
    default:
      return state;
  }
};
